import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSettingsContext } from '../context/settings';

interface ProtectedRouteProps {
  children: React.ReactElement;
  requiresBannerCreation?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiresBannerCreation = false }) => {
  const { settings } = useSettingsContext();

  if (requiresBannerCreation && settings.disableBannerCreation) {
    return <Navigate to='/' replace />;
  }

  return children;
};
